<template>
  <div ref="container">
    <a-modal :title="title" width="80%" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height:80%;">
      <a-card class="box-card">
        <h3>产品标识信息</h3>
        <div class="productInfo">
          <a-row class="a-row">
            <a-col :span="12">
              <span>最小销售单元产品标识：</span>{{productInfo.productDi}}
            </a-col>
            <a-col :span="12">
              <span>产品标识体系编码名称：</span>{{getCodeSystemDetails(productInfo.specCodeSystem)}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>发布时间：</span>{{productInfo.releaseTime}}
            </a-col>
            <a-col :span="12">
              <span>最小销售单元中使用的数量：</span>{{productInfo.minSaleNumber}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>是否与最小销售单元产品标识一致：</span>
              {{productInfo.isSameIdentification===true?'是':'否'}}
            </a-col>
            <a-col :span="12">
              <span>是否与注册/备案产品标识一致：</span>
              {{productInfo.isSameRegistered===true?'是':'否'}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>是否有本体标识：</span>
              {{productInfo.isHaveBody===true?'是':'否'}}
            </a-col>
            <a-col :span="12">
              <span>标识载体：</span>{{getCarrierDetails(productInfo.specCodeSystem)}}
<!--              <a-checkbox v-model="productInfo.identificationCarrier == 2" disabled>二维码</a-checkbox>-->
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>GS1产品编码：</span>{{productInfo.gs1Code}}
            </a-col>
            <a-col :span="12">
              <span>注册时间：</span>{{productInfo.releaseTime}}
            </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card class="box-card">
        <h3>产品基本信息</h3>
        <div class="productInfo">
          <a-row class="a-row">
            <a-col :span="12">
              <span>产品名称/通用名称：</span>{{productInfo.productName}}
            </a-col>
            <a-col :span="12">
              <span>商品名称：</span>{{productInfo.goodsName}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>规格型号：</span>{{productInfo.specificationModel}}
            </a-col>
            <a-col :span="12">
              <span>器械是否为包类产品：</span>
              {{productInfo.isPackage===true?'是':'否'}}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <span>产品描述：</span>{{productInfo.productDetails}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>品类编码：</span>{{productInfo.productNo}}
            </a-col>
            <a-col :span="12">
              <span>原器械目录代码：</span>{{productInfo.originalCode}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>器械类别：</span>
              {{productInfo.deviceCategory == 1?'器械':'体外诊断试剂'}}
            </a-col>
            <a-col :span="12">
              <span>分类编码：</span>{{productInfo.categoryValue}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>磁共振(MR)安全相关信息：</span>{{productInfo.mrSafetyInfo}}
            </a-col>
            <a-col :span="12">
              <span>产品类别：</span>{{productInfo.productType == 1?'设备':'耗材'}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>最大重复使用次数：</span>{{productInfo.maxReuseNumber}}
            </a-col>
            <a-col :span="12">
              <span>是否标记为一次性使用：</span>
              {{productInfo.isDisposable === true?'是':'否'}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>使用前是否需要灭菌：</span>
              {{productInfo.isSterilization === true?'是':'否'}}
            </a-col>
            <a-col :span="12">
              <span>灭菌方式：</span>{{productInfo.sterilizationMethod}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>是否为无菌包装：</span>
              {{productInfo.isAseptic === true?'是':'否'}}
            </a-col>
            <a-col :span="12">
              <span>其它信息的网址链接：</span>{{productInfo.otherUrl}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>医疗器械注册人/备案人名称：</span>{{productInfo.registerName}}
            </a-col>
            <a-col :span="12">
              <span>医疗器械注册人/备案人英文名称：</span>{{productInfo.registerNameEn}}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <span>注册证编号/备案凭证编号：</span>{{productInfo.registerNo}}
            </a-col>
            <a-col :span="12">
              <span>医保编码：</span>{{productInfo.medicalCode}}
            </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card class="box-card">
        <h3>生产标识信息</h3>
        <div class="productInfo">
          <a-row class="a-row">
            <a-col :span="12">
              <span>生产标识是否包含批号：</span>
              {{productInfo.isBatchNumber === true?'是':'否'}}
            </a-col>
            <a-col :span="12">
              <span>生产标识是否包含序列号：</span>
              {{productInfo.isSerialNumber === true?'是':'否'}}
            </a-col>
          </a-row>
          <a-row class="a-row">
            <a-col :span="12">
              <span>生产标识是否包含生产日期：</span>
              {{productInfo.isStartDate === true?'是':'否'}}
            </a-col>
            <a-col :span="12">
              <span>生产标识是否包含失效日期：</span>
              {{productInfo.isEndDate === true?'是':'否'}}
            </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card class="box-card">
        <div style="margin-bottom: 20px; width: 100%;display: flex; flex-direction: row;justify-content: space-between;align-items: center;">
          <h3>储存或操作信息</h3>
        </div>
        <div class="productInfo">
          <a-row class="a-row">
            <a-col :span="24">
              <span>特殊储存或操作条件：</span>{{productInfo.specialConditions}}
            </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card class="box-card">
        <div style="margin-bottom: 20px; width: 100%;display: flex; flex-direction: row;justify-content: space-between;align-items: center;">
          <h3>临床使用尺寸信息</h3>
        </div>
        <div class="productInfo">
          <a-row class="a-row">
            <a-col :span="24">
              <span>特殊尺寸说明：</span>{{productInfo.specialSize}}
            </a-col>
          </a-row>
        </div>
      </a-card>
      <div slot="footer" class="dialog-footer">
        <a-button @click="visible = false">取消</a-button>
        <a-button type="primary" :loading="loadInput" @click="createData(1)" v-if="productInfo.declareStatus == 0">提交</a-button>
        <a-button type="primary" :loading="loadInput" @click="createData(2)" v-if="productInfo.declareStatus == 1">提交</a-button>
        <a-button type="primary" :loading="loadInput" @click="createData(3)" v-if="productInfo.declareStatus == 3">提交</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { getdetailApi, declareDi } from '@/api/api'
export default {
  name: 'report',
  data() {
    return {
      title: '药监局申报',
      visible: false,
      loadInput: false,
      id: '',
      productInfo: {},
    }
  },
  created() {},
  methods: {
    async add(e) {
      console.log(e, 'e1')
      this.visible = true
      if (e.id) {
        this.id = e.id
        this.codeSystem=e.codeSystem
        this.getlist()
      }
    },getCodeSystemDetails:function (value) {
      let code='';
      for (let i = 0; i < value.length; i++) {
        code+=code+value[i]==='1'?'MA(IDcode)'+',':'GS1'+',';
      }
      return code.substring(0,code.length-1);
    },getCarrierDetails:function (value) {
      let code='';
      for (let i = 0; i < value.length; i++) {
        if (value[i]==='2'){
          code+=('一维码'+',');
        }else {
          code+=('二维码'+',');
        }
      }
      return code.substring(0,code.length-1);
    },
    async createData(status) {
      this.loadInput = true
      const res = await declareDi({ id: this.productInfo.id, declareStatus: status, codeSystem:this.codeSystem})
      console.log(res, 'res---')
      if (res.errno == 200) {
        this.loadInput = false
        this.visible = false
        this.$message.success('申报成功')
        this.$emit('ok')
      } else {
        this.loadInput = false
        this.$message.error(res.data || res.errmsg)
      }
    },
    async getlist() {

      console.log(params,'params')
      let params = {
        id: this.id,
        codeSystem:this.codeSystem,
      }
      const res = await getdetailApi(params)
      console.log(res, 'res')
      if (res.errno == 200 && res.errmsg == '成功') {
        console.log(res.data);
        this.productInfo = res.data
        console.log(this.productInfo);
      } else {
        this.$message.error(res.data || res.errmsg)
      }
    },

    close() {
      this.visible = false
      this.$emit('ok')
    },
    handleOk() {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped>
.box-card {
  margin-bottom: 20px;
}

h3 {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 700;
}
.a-row {
  border-bottom: 1px #efefef solid;
  font-size: 12px;
  line-height: 50px;
}
/* .productInfo .a-row {
  border-bottom: 1px #efefef solid;
} */

/* .productInfo .a-col {
  font-size: 12px;
  line-height: 50px;
} */

/* .productInfo .a-col > span {
  display: inline-block;
  width: 220px;
  text-align: right;
} */
</style>